import {
  Box,
  Button,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import Heading from "../../../components/Heading";
import { AiOutlinePlusCircle, AiOutlineSearch } from "react-icons/ai";
import TradingGroupList from "./TradingGroupList";
import { useState } from "react";
import { marginBottomForSmallDevices } from "../../../constants";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { getAllGroups } from "./service";
import { useGetState } from "../../../context/useGetState";
import FullPageLoader from "../../../components/full-page-loader";
import useSmallScreen from "../../../components/useSmallScreen";
import http, { AUTH_ROUTES } from "../../../service/api";
import FilterSettingsModal from "./TradeFilterSettingsModal";
import axios from "axios";
//import "./MySelect.css";

//const getAllgroupsUrl = "https://f8.codester.dev/web/api/groups";
const getAllgroupsUrl = "https://f8.codester.dev/api/groups";

console.log('getAllgroupsUrl: ', getAllgroupsUrl);

function TradingGroup() {
  const { state } = useGetState();
  const { userInfo } = state;
  const [active, setActive] = useState("");
  const [groups, setGroups] = useState([]);
  const [nextPage, setNextPage] = useState(getAllgroupsUrl);
  const [searchText, setSearchText] = useState("");
  const [categoryText, setCategoryText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [loading, setLoading] = useState(true);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [categories, setCategories] = useState();
  const [isSearch, setIsSearch] = useState(false);
  const [isCategory, setIsCategory] = useState(false);

  const token = sessionStorage.getItem("#f8WEB#");

  // Define headers with the bearer token
  const headers = {
    Authorization: `Bearer ${token}`,
    // Other headers if needed
  };

  const navigate = useNavigate();
  let toggleColor = useColorModeValue("#000", "#000");
  let tabBoxShadowColor = useColorModeValue(
    "-1px 20px 15px 0px #80808017",
    "9px 20px 20px 0px #fafafa12"
  );
  const roundColor = useColorModeValue("#0076FF", "#0076FF");
  const [smallScreen] = useSmallScreen();

  const tabstyle = {
    borderRadius: "10px",
    cursor: "pointer",
    boxShadow: tabBoxShadowColor,
    alignItems: "center",
    fontWeight: "100",
    fontSize: ".8em",
  };

  const inputStyle = {
    bg: "#000",
    color: "#fff",
    _placeholder: { color: "#fff" },
    borderRadius: "20px",
    cursor: "pointer",
    boxShadow: "2px 2px 9px 0px #80808021",
    fontWeight: "100",
    fontSize: ".8em",
    width: "200px",
  };
  const selectCustomStyles = {
    // Custom styles for the Select component
    control: (styles) => ({
      ...styles,
      borderRadius: "20px", // Adjust the radius as needed
    }),
  };

  let act = {
    borderRadius: "10px",
    bg: "#4F46BA",
    color: "#fff",
  };

  const accountType = userInfo?.account_type ? "" : "";

  const handleChange = (event) => {
    setActive(event.target.value);
  };

  const handleSearchFilter = (event) => {
    setIsSearch(true);
    setSearchText(event.target.value);
  };
  const handleCategoryFilter = (event) => {
    setIsCategory(true);
    setCategoryText(event.target.value);
  };

  useEffect(() => {
    //console.log("catText: ", categoryText);
  }, [categoryText]);

  useEffect(() => {
    // Initial data fetch
    fetchData(getAllgroupsUrl);
  }, [selectedCategory]);

  const fetchData = async (url) => {
    // Make an API request to fetch data
    const response = await axios.get(url, { headers });
    const responseData = response?.data;
    //console.log('responseData: ', responseData);
    
    //////////////////////
    setLoading(false);
    return setGroups(responseData?.data); //break code here untill nextPage issue is fixed, to avoid duplicates
    //////////////////////
    // console.log('CurrentData: ', responseData?.data);
    // console.log('NextData: ', responseData?.links?.next);
    const nextData = response?.data?.links?.next

    // Check if there is a "next" attribute
    if (nextData) {
      setNextPage(nextData);
    } else {
      setNextPage(null);
    }
    

    // Filter out duplicate groups based on their IDs
    // let result = _.unionBy(responseData?.data, groups, "id");
       let result = responseData?.data.map(
         function (a) {
           return this[a?.id] || a;
         },
         groups.reduce(function (r, a) {
           r[a?.id] = a;
           return r;
         }, Object.create(null))
       );
    console.log("data", result);

  const uniqueGroups = responseData?.data.filter((group) => {
    const isDuplicate = groups.some((existingGroup) => existingGroup?.id === group?.id);
    return !isDuplicate;
  });


    // Append the data to the existing state
    setGroups((prevData) => [...prevData, ...responseData?.data]);
    setLoading(false);

    // Append the unique data to the existing state
    setLoading(false);
    return setGroups((prevData) => [...prevData, ...uniqueGroups]);
    
    // setGroups((prevData) => [...prevData, ...result]);
    // setGroups(result);
    // setLoading(false);
  };

  const handleScroll = () => {
    // Check if the user has scrolled to the bottom and there's a next page
    if (
      window.innerHeight + window.scrollY >= document.body.scrollHeight &&
      nextPage
    ) {
      fetchData(nextPage);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [nextPage]);

  useEffect(() => {
    async function fetchCategories() {
      const res = await http.get(AUTH_ROUTES.GET_GROUP_CATEGORIES);
      setCategories(res?.data);
    }
    fetchCategories();
  }, []);

  return loading ? (
    <FullPageLoader />
  ) : (
    <Stack>
      <Stack
        direction={"row"}
        alignItems="flex-start"
        justifyContent={"space-between"}
        mb="20px"
        flexWrap={"wrap"}
      >
        <Stack
          direction={"row"}
          alignItems="center"
          spacing={"20px"}
          mb={{ sm: "20px" }}
        >
          <Heading>Groups</Heading>
          <Stack
            direction={"row"}
            alignItems="center"
            w="150px"
            borderRadius={"10px"}
            bg="#1391E6"
            color="#fff"
            boxShadow={"2px 2px 8px 0px #1391e67d"}
            cursor="pointer"
            onClick={() => navigate("/create-group")}
            px="10px"
            boxSize={"initial"}
            spacing="-1"
          >
            <AiOutlinePlusCircle color="#fff" fontSize={"1.8em"} />
            <Button
              bg="transparent"
              size="sm"
              fontWeight="500"
              fontSize={".95em"}
            >
              Create Group
            </Button>
          </Stack>
        </Stack>

        <Stack direction={"row"} display={"none"}>
          <Stack
            direction="row"
            {...tabstyle}
            bg={"#fff"}
            justifyContent="space-between"
            color={toggleColor}
          >
            <Text
              onClick={() => setActive("forex")}
              p="10px 35px"
              {...(active === "forex" ? act : {})}
            >
              Forex
            </Text>
            <Text
              onClick={() => setActive("crypto")}
              p="10px 35px"
              {...(active === "crypto" ? act : {})}
            >
              Crypto
            </Text>
            <Text
              onClick={() => setActive("binary")}
              p="10px 35px"
              {...(active === "binary" ? act : {})}
            >
              Binary
            </Text>
          </Stack>
        </Stack>

        <Stack direction={"row"} display={"none"}>
          <Select {...inputStyle} value={active} defaultValue={"default"}>
            <option value="forex" disabled color="#718096">
              Group Actions
            </option>
            <option value="forex" color="#718096">
              Delete Group
            </option>
          </Select>
        </Stack>

        <Stack direction={"row"}>
          <Select
            {...inputStyle}
            defaultValue={""}
            value={categoryText}
            onChange={handleCategoryFilter}
          >
            <option value="" style={{ color: "#718096" }}>
              Select Category
            </option>
            {categories?.length > 0 &&
              categories.map((cat, index) => (
                <option
                  key={index}
                  value={cat?.name}
                  style={{ color: "#718096" }}
                >
                  {cat?.name}
                </option>
              ))}
          </Select>
        </Stack>

        <Stack
          direction={"row"}
          alignItems="center"
          w={["100%", "unset"]}
          flexFlow={["row-reverse", "unset"]}
          justifyContent={["space-between", "unset"]}
        >
          <Box
            display={"none"}
            cursor="pointer"
            ml={["10px !important", "unset"]}
            border={`1px solid ${roundColor}`}
            borderRadius="50%"
            p="5px"
            onClick={() => setFilterModalOpen(true)}
          ></Box>
          <InputGroup>
            <InputRightElement
              pointerEvents="none"
              children={
                <Stack
                  borderRadius="50%"
                  w="30px"
                  h="30px"
                  bg="#FF686B"
                  justifyContent={"center"}
                  alignItems="center"
                >
                  <AiOutlineSearch color="#fff" />
                </Stack>
              }
            />
            <Input
              type="text"
              placeholder="Search Group"
              borderRadius={"20px"}
              _placeholder={{ fontSize: ".8em" }}
              boxShadow="2px 2px 9px 0px #80808021"
              onChange={handleSearchFilter}
            />
          </InputGroup>
          <FilterSettingsModal
            isOpen={filterModalOpen}
            onClose={() => setFilterModalOpen(false)}
          />
        </Stack>
      </Stack>
      {groups?.length > 0 ? (
        <TradingGroupList
          //groups={groups?.filter((group) => group)}
          groups={groups}
          accountType={"account type"}
          searchText={searchText}
          categoryText={categoryText}
          isCategory={isCategory}
          isSearch={isSearch}
        />
      ) : (
        <Text textAlign="center">There's no group available</Text>
      )}
    </Stack>
  );
}

export default TradingGroup;
